module.exports = __webpack_public_path__ + "img/12.f2a09f08.gif";